<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "InformasiCampaign",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
